import React, { useEffect, useState } from "react";
import "./Become.css";
import Overly from "../../assets/images/overly.png";
import InputFeild from "components/Input/Input";
import { Button } from "components";
import Header from "pages/Home1/Header";
import Footer from "components/Footer";
import { MdOutlineAttachment } from "react-icons/md";
import { MdOutlineImage } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

const modalStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  padding: "20px",
  zIndex: 1000,
  borderRadius: "10px",
  width: "400px",
  boxShadow: "0 0 10px rgba(0,0,0,0.25)",
};

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  zIndex: 999,
};

const AddBusniessDetails = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigation = useNavigate();
  const location = useLocation();
  const { item } = location.state || {};
  const { user } = item || {};
  const token = localStorage.getItem("accessToken");
  const [formData, setFormData] = useState({
    companyName: "",
    location: "",
    vatNumber: "",
    uploadDoc: null,
    uploadImage: null,       // NEW: business image
    description: "",         // NEW: business description
    fullName: "",
    position: "" || "Car Washing",
    email: user?.email || "",
    business_license: "",
    bank_details: {
      bankName: "",
      accountHolderName: "",
      accountNumber: "",
      iban: "",
    },
  });

  const handleBankDetailsChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      bank_details: {
        ...prevData.bank_details,
        [field]: value,
      },
    }));
  };

  const [uploading, setUploading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
    getCurrentLocation();
  }, []);

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          try {
            const response = await axios.get(
              `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyB_nNvYWSCB2haI7DCgR6chQmsg-T4oj8s`,
            );
            const locationName = response.data.results[0].formatted_address;
            setFormData((prevData) => ({
              ...prevData,
              location: locationName || "",
            }));
          } catch (error) {
            console.error("Error fetching location:", error);
          }
        },
        (error) => {
          console.error("Error getting current location:", error);
        },
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  const handleChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setFormData((prev) => ({
      ...prev,
      bank_details: {
        bankName: "",
        accountHolderName: "",
        accountNumber: "",
        iban: "",
      },
    }));
  };

  // Existing PDF doc handler
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFormData((prevData) => ({
        ...prevData,
        uploadDoc: selectedFile,
      }));
      e.target.value = null;
    }
  };

  const handleRemoveFile = () => {
    setFormData({ ...formData, uploadDoc: null });
  };

  // NEW: Image upload handler
  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFormData((prevData) => ({
        ...prevData,
        uploadImage: selectedFile,
      }));
      e.target.value = null;
    }
  };

  const handleRemoveImage = () => {
    setFormData({ ...formData, uploadImage: null });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.companyName)
      newErrors.companyName = "Shop Name is required.";
    if (!formData.location) newErrors.location = "Location is required.";
    if (!formData.vatNumber)
      newErrors.vatNumber = "TAX Registration Number is required.";
    if (!formData.business_license)
      newErrors.business_license = "Business License Number is required.";
    if (!formData.bank_details)
      newErrors.bank_details = "Bank Details is required.";
    if (!formData.uploadDoc) newErrors.uploadDoc = "Please upload a document.";
    if (!formData.description)                          // NEW validation
      newErrors.description = "Description is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      setUploading(true);

      // Upload PDF document
      const uploadFormData = new FormData();
      uploadFormData.append("file", formData.uploadDoc);
      const uploadResponse = await axios.post(
        "https://production.washta.com/api/uploadFile",
        uploadFormData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      const documentUrl = uploadResponse.data.data.path;

      // NEW: Upload business image (if provided)
      let imageUrl = "";
      if (formData.uploadImage) {
        const imageFormData = new FormData();
        imageFormData.append("file", formData.uploadImage);
        const imageResponse = await axios.post(
          "https://production.washta.com/api/uploadFile",
          imageFormData,
          { headers: { "Content-Type": "multipart/form-data" } },
        );
        imageUrl = imageResponse.data.data.path;
      }

      const businessDetails = {
        uploadDocument: documentUrl,
        businessImage: imageUrl,           // NEW field
        description: formData.description, // NEW field
        companyName: formData.companyName,
        location: formData.location,
        VATNumber: formData.vatNumber,
        fullName: formData.fullName || "",
        position: formData.position,
        email: formData.email,
        business_license: formData.business_license,
        bank_name: formData?.bank_details.bankName,
        account_holder_name: formData?.bank_details.accountHolderName,
        account_number: formData?.bank_details.accountNumber,
        iban: formData?.bank_details.iban,
      };

      await axios.post(
        `https://production.washta.com/api/seller/Business/${item?.user?.id}`,
        businessDetails,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      toast.success(
        "Successful sign up. Our team will update your request shortly",
      );

      setFormData({
        companyName: "",
        location: "",
        vatNumber: "",
        uploadDoc: null,
        uploadImage: null,
        description: "",
        fullName: "",
        position: "",
        email: user?.email || "",
        bank_details: {
          bankName: "",
          accountHolderName: "",
          accountNumber: "",
          iban: "",
        },
      });

      setTimeout(() => {
        navigation("/not-verified");
      }, 2000);
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      <Header
        btnText="Become a Partner"
        btnLink={() => navigation("/become-a-partner")}
      />
      <div style={{ position: "relative" }}>
        <div className="row">
          <img src={Overly} className="overlyClassName" alt="Logo" />
          <div className="addbussiness-detsilsx w-[60%] md:w-[100%] md:mt-[30%]">
            <div className="innerDiv-form md:w-auto">
              <h1 className="h1-heaing md:text-[25px]">
                Add your business details
              </h1>

              <InputFeild
                paddingBottom="5px"
                type="text"
                label="Shop Name *"
                placeholder="Shop Name"
                value={formData.companyName}
                onChange={(value) => handleChange("companyName", value)}
              />
              {errors.companyName && (
                <p className="error-text">{errors.companyName}</p>
              )}

              <div className="gapmargin">
                <InputFeild
                  paddingBottom="5px"
                  type="text"
                  label="Location *"
                  placeholder="Location"
                  value={formData.location}
                  onChange={(value) => handleChange("location", value)}
                />
                {errors.location && (
                  <p className="error-text">{errors.location}</p>
                )}
              </div>

              <div className="gapmargin">
                <InputFeild
                  paddingBottom="5px"
                  type="text"
                  label="TAX Registration Number *"
                  placeholder="TAX Registration Number"
                  value={formData.vatNumber}
                  onChange={(value) => handleChange("vatNumber", value)}
                />
                {errors.vatNumber && (
                  <p className="error-text">{errors.vatNumber}</p>
                )}
              </div>

              <div className="gapmargin">
                <InputFeild
                  paddingBottom="5px"
                  type="text"
                  label="Business License *"
                  placeholder="Business License Number"
                  value={formData.business_license}
                  onChange={(value) => handleChange("business_license", value)}
                />
                {errors.business_license && (
                  <p className="error-text">{errors.business_license}</p>
                )}
              </div>

              {/* Bank Details trigger */}
              <div className="gapmargin" onClick={() => setIsModalOpen(true)}>
                <label
                  style={{
                    cursor: "pointer",
                    width: "100%",
                    color: "#d9dbed",
                    fontSize: "16px",
                    borderBottom: "1px solid white",
                    paddingBottom: "10px",
                  }}
                >
                  Bank Details *
                </label>
              </div>

              {/* PDF Document Upload */}
              <div
                className="gapmargin"
                style={{
                  display: "flex",
                  position: "relative",
                  borderBottom: "1px solid white",
                  paddingBottom: 10,
                }}
              >
                <input
                  type="file"
                  id="fileUpload"
                  accept=".pdf"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
                {!formData.uploadDoc ? (
                  <label
                    htmlFor="fileUpload"
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      color: "#d9dbed",
                      fontSize: "16px",
                    }}
                  >
                    Upload Document *
                  </label>
                ) : (
                  <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                    <p className="uploaded-file-name" style={{ color: "white", fontWeight: 100 }}>
                      {formData.uploadDoc.name}
                    </p>
                    <button
                      onClick={handleRemoveFile}
                      style={{
                        marginLeft: "10px",
                        cursor: "pointer",
                        background: "none",
                        border: "none",
                        color: "red",
                        fontSize: "14px",
                      }}
                    >
                      Remove
                    </button>
                  </div>
                )}
                <MdOutlineAttachment
                  style={{
                    position: "absolute",
                    right: "10px",
                    color: "white",
                    fontSize: "20px",
                    transform: "rotate(45deg)",
                  }}
                />
              </div>
              {errors.uploadDoc && (
                <p className="error-text">{errors.uploadDoc}</p>
              )}

              {/* ── NEW: Business Image Upload ── */}
              <div
                className="gapmargin"
                style={{
                  display: "flex",
                  position: "relative",
                  borderBottom: "1px solid white",
                  paddingBottom: 10,
                }}
              >
                <input
                  type="file"
                  id="imageUpload"
                  accept="image/*"
                  onChange={handleImageChange}
                  style={{ display: "none" }}
                />
                {!formData.uploadImage ? (
                  <label
                    htmlFor="imageUpload"
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      color: "#d9dbed",
                      fontSize: "16px",
                    }}
                  >
                    Upload Business Image
                  </label>
                ) : (
                  <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                    <img
                      src={URL.createObjectURL(formData.uploadImage)}
                      alt="Business preview"
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "cover",
                        borderRadius: "6px",
                        marginRight: "10px",
                      }}
                    />
                    <p style={{ color: "white", fontWeight: 100, flex: 1 }}>
                      {formData.uploadImage.name}
                    </p>
                    <button
                      onClick={handleRemoveImage}
                      style={{
                        marginLeft: "10px",
                        cursor: "pointer",
                        background: "none",
                        border: "none",
                        color: "red",
                        fontSize: "14px",
                      }}
                    >
                      Remove
                    </button>
                  </div>
                )}
                <MdOutlineImage
                  style={{
                    position: "absolute",
                    right: "10px",
                    color: "white",
                    fontSize: "20px",
                  }}
                />
              </div>

              {/* ── NEW: Description ── */}
              <div className="gapmargin">
                <div
                  style={{
                    borderBottom: "1px solid white",
                    paddingBottom: "10px",
                  }}
                >
                  <label
                    style={{
                      color: "#d9dbed",
                      fontSize: "16px",
                      display: "block",
                      marginBottom: "6px",
                    }}
                  >
                    Description *
                  </label>
                  <textarea
                    placeholder="Write a short description about your business..."
                    value={formData.description}
                    onChange={(e) => handleChange("description", e.target.value)}
                    rows={3}
                    style={{
                      width: "100%",
                      background: "transparent",
                      border: "none",
                      outline: "none",
                      color: "white",
                      fontSize: "16px",
                      fontFamily: "'General Sans', sans-serif",
                      resize: "none",
                    }}
                  />
                </div>
                {errors.description && (
                  <p className="error-text">{errors.description}</p>
                )}
              </div>

              <div className="gapmargin">
                <InputFeild
                  paddingBottom="5px"
                  type="text"
                  label="Position"
                  placeholder="Position"
                  value={formData.position}
                  onChange={(value) => handleChange("position", value)}
                />
                {errors.position && (
                  <p className="error-text">{errors.position}</p>
                )}
              </div>

              <div className="gapmargin">
                <Button
                  onClick={handleFormSubmit}
                  shape="round"
                  className="min-w-[100%] sm:px-1"
                  style={{
                    fontSize: "16px",
                    background: "white",
                    color: "black",
                    marginTop: "20px",
                    fontFamily: "'General Sans', sans-serif",
                  }}
                  disabled={uploading}
                >
                  {uploading ? "Uploading..." : "Finish"}
                </Button>
              </div>
            </div>
          </div>

          {/* Bank Details Modal */}
          {isModalOpen && (
            <>
              <div style={overlayStyle} onClick={() => setIsModalOpen(false)} />
              <div className="bg-[#747EEF]" style={modalStyle}>
                <h3 className="h1-heaing text-[20px]">Enter Bank Details</h3>

                <div style={{ marginBottom: "10px" }}>
                  <InputFeild
                    paddingBottom="5px"
                    type="text"
                    label="Bank Name*"
                    placeholder="Bank Name"
                    value={formData?.bank_details?.bankName}
                    onChange={(value) => handleBankDetailsChange("bankName", value)}
                  />
                  {errors.bankName && <p className="error-text">{errors.bankName}</p>}
                </div>

                <div style={{ marginBottom: "10px" }}>
                  <InputFeild
                    paddingBottom="5px"
                    type="text"
                    label="Account Holder Name *"
                    placeholder="Account Holder Name"
                    value={formData?.bank_details?.accountHolderName}
                    onChange={(value) => handleBankDetailsChange("accountHolderName", value)}
                  />
                  {errors.accountHolderName && (
                    <p className="error-text">{errors.accountHolderName}</p>
                  )}
                </div>

                <div style={{ marginBottom: "10px" }}>
                  <InputFeild
                    paddingBottom="5px"
                    type="number"
                    validatePhone={false}
                    label="Account Number *"
                    placeholder="Account Number"
                    value={formData?.bank_details?.accountNumber}
                    onChange={(value) => handleBankDetailsChange("accountNumber", value)}
                  />
                  {errors.accountNumber && (
                    <p className="error-text">{errors.accountNumber}</p>
                  )}
                </div>

                <div style={{ marginBottom: "10px" }}>
                  <InputFeild
                    paddingBottom="5px"
                    type="text"
                    label="IBAN *"
                    placeholder="IBAN"
                    value={formData?.bank_details?.iban}
                    onChange={(value) => handleBankDetailsChange("iban", value)}
                  />
                  {errors.iban && <p className="error-text">{errors.iban}</p>}
                </div>

                <div className="flex justify-between" style={{ textAlign: "right" }}>
                  <Button
                    onClick={handleCancel}
                    shape="round"
                    className="min-w-[48%] sm:px-1"
                    style={{
                      fontSize: "13px",
                      background: "#747EEF",
                      color: "white",
                      marginTop: "20px",
                      fontFamily: "'General Sans', sans-serif",
                      border: "1px solid white",
                    }}
                    disabled={uploading}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => setIsModalOpen(false)}
                    shape="round"
                    className="min-w-[48%] sm:px-1"
                    style={{
                      fontSize: "13px",
                      background: "white",
                      color: "black",
                      marginTop: "20px",
                      fontFamily: "'General Sans', sans-serif",
                    }}
                    disabled={uploading}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <ToastContainer />
      <Footer />
    </>
  );
};

export default AddBusniessDetails;